import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _FormTemplateFieldUpload;
import { tracked } from "@glimmer/tracking";
import Component, { setComponentTemplate } from "@ember/component";
import { computed } from "@ember/object";
import { dasherize } from "@ember/string";
import { htmlSafe } from "@ember/template";
import PickFilesButton from "discourse/components/pick-files-button";
import { isAudio, isImage, isVideo } from "discourse/lib/uploads";
import UppyUploadMixin from "discourse/mixins/uppy-upload";
import icon from "discourse-common/helpers/d-icon";
import { createTemplateFactory } from "@ember/template-factory";
let FormTemplateFieldUpload = (_dec = computed("uploadingOrProcessing"), (_class = (_FormTemplateFieldUpload = class FormTemplateFieldUpload extends Component.extend(UppyUploadMixin) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "uploadValue", _descriptor, this);
    _initializerDefineProperty(this, "uploadedFiles", _descriptor2, this);
    _initializerDefineProperty(this, "disabled", _descriptor3, this);
    _initializerDefineProperty(this, "fileUploadElementId", _descriptor4, this);
    _initializerDefineProperty(this, "fileInputSelector", _descriptor5, this);
    _defineProperty(this, "type", "composer");
  }
  get uploadStatusLabel() {
    return this.uploadingOrProcessing ? "form_templates.upload_field.uploading" : "form_templates.upload_field.upload";
  }
  /**
  * The validation from PickFilesButton._filesPicked, where acceptedFormatsOverride
  * is validated and displays a message, happens after the upload is complete.
  *
  * Overriding this method allows us to validate the file before the upload
  *
  * @param file
  * @returns {boolean}
  */
  isUploadedFileAllowed(file1) {
    // same logic from PickFilesButton._hasAcceptedExtensionOrType
    const fileTypes1 = this.attributes.file_types;
    const extension1 = file1.name.split(".").pop();
    return !fileTypes1 || fileTypes1.includes(`.${extension1}`) || fileTypes1.includes(file1.type);
  }
  uploadDone(upload1) {
    // If re-uploading, clear the existing file if multiple aren't allowed
    if (!this.attributes.allow_multiple && this.uploadValue) {
      this.uploadedFiles = [];
      this.uploadValue = "";
    }
    this.uploadedFiles.pushObject(upload1);
    const uploadMarkdown1 = this.buildMarkdown(upload1);
    if (this.uploadValue && this.allowMultipleFiles) {
      // multiple file upload
      this.uploadValue = `${this.uploadValue}\n${uploadMarkdown1}`;
    } else {
      // single file upload
      this.uploadValue = uploadMarkdown1;
    }
  }
  buildMarkdown(upload1) {
    if (isImage(upload1.url)) {
      return `![${upload1.file_name}|${upload1.width}x${upload1.height}](${upload1.short_url})`;
    }
    if (isAudio(upload1.url)) {
      return `![${upload1.file_name}|audio](${upload1.short_url})`;
    }
    if (isVideo(upload1.url)) {
      return `![${upload1.file_name}|video](${upload1.short_url})`;
    }
    return `[${upload1.file_name}|attachment](${upload1.short_url}) (${upload1.human_filesize})`;
  }
}, setComponentTemplate(createTemplateFactory(
/*
  
    <div class="control-group form-template-field" data-field-type="upload">
      {{#if @attributes.label}}
        <label class="form-template-field__label">
          {{@attributes.label}}
          {{#if @validations.required}}
            {{icon "asterisk" class="form-template-field__required-indicator"}}
          {{/if}}
        </label>
      {{/if}}

      {{#if @attributes.description}}
        <span class="form-template-field__description">
          {{htmlSafe @attributes.description}}
        </span>
      {{/if}}

      <input type="hidden" name={{@id}} value={{this.uploadValue}} />

      <PickFilesButton
        @fileInputClass="form-template-field__upload"
        @fileInputId={{this.fileUploadElementId}}
        @allowMultiple={{@attributes.allow_multiple}}
        @showButton={{true}}
        @onFilesPicked={{true}}
        @icon="upload"
        @label={{this.uploadStatusLabel}}
        @fileInputDisabled={{this.disabled}}
        @acceptedFormatsOverride={{@attributes.file_types}}
        @acceptedFileTypesString={{@attributes.file_types}}
      />

      {{#if this.uploadedFiles}}
        <ul class="form-template-field__uploaded-files">
          {{#each this.uploadedFiles as |file|}}
            <li>
              {{icon "file"}}
              <a
                href={{file.url}}
                target="_blank"
                rel="noopener noreferrer"
              >{{file.file_name}}</a>
              <span>{{file.human_filesize}}</span>
            </li>
          {{/each}}
        </ul>
      {{/if}}
    </div>
  
*/
{
  "id": "4icEXmtw",
  "block": "[[[1,\"\\n    \"],[10,0],[14,0,\"control-group form-template-field\"],[14,\"data-field-type\",\"upload\"],[12],[1,\"\\n\"],[41,[30,1,[\"label\"]],[[[1,\"        \"],[10,\"label\"],[14,0,\"form-template-field__label\"],[12],[1,\"\\n          \"],[1,[30,1,[\"label\"]]],[1,\"\\n\"],[41,[30,2,[\"required\"]],[[[1,\"            \"],[1,[28,[32,0],[\"asterisk\"],[[\"class\"],[\"form-template-field__required-indicator\"]]]],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,1,[\"description\"]],[[[1,\"        \"],[10,1],[14,0,\"form-template-field__description\"],[12],[1,\"\\n          \"],[1,[28,[32,1],[[30,1,[\"description\"]]],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n      \"],[10,\"input\"],[15,3,[30,3]],[15,2,[30,0,[\"uploadValue\"]]],[14,4,\"hidden\"],[12],[13],[1,\"\\n\\n      \"],[8,[32,2],null,[[\"@fileInputClass\",\"@fileInputId\",\"@allowMultiple\",\"@showButton\",\"@onFilesPicked\",\"@icon\",\"@label\",\"@fileInputDisabled\",\"@acceptedFormatsOverride\",\"@acceptedFileTypesString\"],[\"form-template-field__upload\",[30,0,[\"fileUploadElementId\"]],[30,1,[\"allow_multiple\"]],true,true,\"upload\",[30,0,[\"uploadStatusLabel\"]],[30,0,[\"disabled\"]],[30,1,[\"file_types\"]],[30,1,[\"file_types\"]]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"uploadedFiles\"]],[[[1,\"        \"],[10,\"ul\"],[14,0,\"form-template-field__uploaded-files\"],[12],[1,\"\\n\"],[42,[28,[31,2],[[28,[31,2],[[30,0,[\"uploadedFiles\"]]],null]],null],null,[[[1,\"            \"],[10,\"li\"],[12],[1,\"\\n              \"],[1,[28,[32,0],[\"file\"],null]],[1,\"\\n              \"],[10,3],[15,6,[30,4,[\"url\"]]],[14,\"target\",\"_blank\"],[14,\"rel\",\"noopener noreferrer\"],[12],[1,[30,4,[\"file_name\"]]],[13],[1,\"\\n              \"],[10,1],[12],[1,[30,4,[\"human_filesize\"]]],[13],[1,\"\\n            \"],[13],[1,\"\\n\"]],[4]],null],[1,\"        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n  \"]],[\"@attributes\",\"@validations\",\"@id\",\"file\"],false,[\"if\",\"each\",\"-track-array\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/form-template-field/upload.js",
  "scope": () => [icon, htmlSafe, PickFilesButton],
  "isStrictMode": true
}), _FormTemplateFieldUpload), _FormTemplateFieldUpload), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "uploadValue", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "uploadedFiles", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "disabled", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.uploadingOrProcessing;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "fileUploadElementId", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return `${dasherize(this.id)}-uploader`;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "fileInputSelector", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return `#${this.fileUploadElementId}`;
  }
}), _applyDecoratedDescriptor(_class.prototype, "uploadStatusLabel", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "uploadStatusLabel"), _class.prototype)), _class));
export { FormTemplateFieldUpload as default };